import * as React from 'react';
export const mobileWalletSvg = React.forwardRef(function mobileWalletSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M1.75 1.5A1.75 1.75 0 0 0 0 3.25v7C0 11.216.784 12 1.75 12h5a.75.75 0 0 0 0-1.5h-5a.25.25 0 0 1-.25-.25V6.01h12.25a.75.75 0 0 0 .75-.75V3.25a1.75 1.75 0 0 0-1.75-1.75h-11ZM13 4.51V3.25a.25.25 0 0 0-.25-.25h-11a.25.25 0 0 0-.25.25v1.26H13Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M13.19 7.23a.75.75 0 0 1 1.06-.02c1.157 1.111 1.747 2.442 1.75 3.945v.003c-.003 1.507-.542 2.972-1.75 4.133a.75.75 0 0 1-1.04-1.082c.891-.856 1.287-1.92 1.29-3.053-.003-1.065-.405-2.015-1.29-2.865a.75.75 0 0 1-.02-1.06Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M12.23 8.539a.75.75 0 0 0-1.038 1.082c.923.886.92 2.303.002 3.176a.75.75 0 1 0 1.034 1.086 3.67 3.67 0 0 0 .002-5.344Zm-2.117 1.464a.75.75 0 0 0-1.046 1.074c.087.085.087.17 0 .256a.75.75 0 0 0 1.046 1.074 1.668 1.668 0 0 0 0-2.404ZM2.32 8.79a.75.75 0 0 1 .75-.75h1.68a.75.75 0 1 1 0 1.5H3.07a.75.75 0 0 1-.75-.75Z',
    }),
  );
});
mobileWalletSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var mobileWallet = {
  category: 'icon',
  colorable: true,
  name: 'mobileWallet',
  svg: mobileWalletSvg,
};
